import { FormEvent, useState } from 'react';
import { Button, Col, Form, Row, Stack } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CustomFormInput from '../../components/CustomFormInput';
import useAPIError from '../../hooks/apiError.context';
import useAuth from '../../hooks/auth.hook';

const PasswordReset = () => {
  const initialFeedback = 'Confirme su contraseña.';

  const auth = useAuth();
  const apiError = useAPIError();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [validated, setValidated] = useState(false);
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [feedback] = useState(initialFeedback);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const form = event.currentTarget;
    const isFormValid = form.checkValidity();

    if (!isFormValid) {
      setValidated(true);
      return;
      // if (passwordConfirm) {
      // setFeedback(initialFeedback);
      // } else if (password !== passwordConfirm) {
      // setFeedback('Las claves no coinciden');
      // }
    }

    try {
      const requestData = {
        recoveryToken: searchParams.get('token') || '',
        newPassword: password,
        newPasswordConfirm: passwordConfirm
      };

      await auth.resetPassword(requestData);
      apiError.showMessage('Se actualizó las credenciales');
      navigate('../login');
    } catch (err) {
      apiError.showError(err as Error);
      setValidated(false);
    }
  };

  return (
    <Stack gap={1} className="py-3 pb-4">
      <div>
        <h4 className="text-primary text-center">Restablecer contraseña</h4>
      </div>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Row className="justify-content-around">
          <Col xs={9}>
            <CustomFormInput
              type="password"
              placeholder="Nueva contraseña"
              feedback="Ingrese una contraseña válida."
              minLength={8}
              value={password}
              onChange={(ev) => setPassword(ev.target.value)}
              required
            />
            <CustomFormInput
              type="password"
              placeholder="Confirmar contraseña"
              feedback={feedback}
              minLength={8}
              value={passwordConfirm}
              onChange={(ev) => setPasswordConfirm(ev.target.value)}
              required
            />
          </Col>
        </Row>
        <br />
        <Row className="justify-content-around">
          <Col className="d-flex align-items-center" xs={10} md={6}>
            <Button type="submit" className="w-100">
              Enviar
            </Button>
          </Col>
        </Row>
      </Form>
    </Stack>
  );
};

export default PasswordReset;
